export default __webpack_public_path__ + "static/media/close.b0c42053.svg";